import {gql} from "@apollo/client";

export const GQL_AUDIT_LOGS_QUERY = gql`
  query AuditLogs($limit: Int!, $offset: Int, $search: String, $object_type: AuditLogObjectType) {
    auditLogs(limit: $limit, offset: $offset, search: $search, object_type: $object_type) {
      total
      items {
        id
        created_at
        user_display
        model_display
        object_str
        object_id
        comment
        changes_list {
          class
          verbose_name
          to_many
          added {
            id
            verbose
          }
          removed {
            id
            verbose
          }
          new {
            value
            verbose
          }
          old {
            value
            verbose
          }
        }
      }
    }
  }
`;
